import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

export interface IRecordBtnState {
  disable: boolean
  spinning: boolean
  isRecordingUnavailable: boolean
  isOpenUnavailableRecordingPopup: boolean
  isRecording: boolean
}

export const initialRecordState: IRecordBtnState = {
  disable: false,
  spinning: false,
  isRecordingUnavailable: false,
  isOpenUnavailableRecordingPopup: false,
  isRecording: false,
}

const recordAdapter = createEntityAdapter()

export const recordSlice = createSlice({
  name: 'record',
  initialState: recordAdapter.getInitialState(initialRecordState),
  reducers: {
    setRecordState: (state, action: PayloadAction<IRecordBtnState>) => ({
      ...state,
      ...action.payload,
    }),
    resetRecordState: (state) => ({ ...state, ...initialRecordState }),
    closeUnavailableRecordingPopup: (state) => {
      state.isOpenUnavailableRecordingPopup = false
    },
    spinAndDisableRecordBtn: (state) => ({ ...state, spinning: true, disable: true }),
    startRecord: (state) => ({ ...state, isRecording: true }),
    stopRecord: (state) => ({ ...state, isRecording: false }),
  },
})

export const {
  setRecordState,
  resetRecordState,
  closeUnavailableRecordingPopup,
  spinAndDisableRecordBtn,
  startRecord,
  stopRecord,
} = recordSlice.actions

export const { selectAll: recordSelector } = recordAdapter.getSelectors(
  (state: RootState) => state[recordSlice.name],
)

export const selectRecordState = (state: RootState) => state.record
export const selectIsRecording = (state: RootState) => state.record.isRecording
